// extracted by mini-css-extract-plugin
module.exports = {"container":"Buttons_container__2PrEk","hover":"Buttons_hover__1PKn9","btn":"Buttons_btn__2IqX7","btnProceed":"Buttons_btnProceed__2ezA7","btnCancel":"Buttons_btnCancel__AW7JK"};